module.exports = __webpack_public_path__ + "static/img/coupon-on.61c7daf9.png";